import { compressImage as compressImageHelper } from '@/utils/imageHelper'

export function compressImage(
  file: globalThis.File,
  maxWidth = 800,
  maxHeight = 800,
  quality = 0.7,
): Promise<globalThis.File> {
  // Re-export the helper function
  return compressImageHelper(file, maxWidth, maxHeight, quality)
}

export async function uploadImage(file: globalThis.File, path?: string): Promise<string> {
  const { getFileService } = await import('@/services/serviceFactory')
  const fileService = await getFileService()

  const compressedFile = await compressImageHelper(file)
  // Generate a unique default path if one isn't provided
  const filePath = path || `images/${generateUniqueId()}-${sanitizeFileName(compressedFile.name)}`
  const { url } = await fileService.upload(compressedFile, filePath, { compress: false })
  return url
}

function generateUniqueId(): string {
  const g = globalThis as typeof globalThis & {
    crypto?: { randomUUID?: () => string }
  }
  if (g.crypto?.randomUUID) {
    return g.crypto.randomUUID()
  }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`
}

function sanitizeFileName(name: string): string {
  const lastDotIndex = name.lastIndexOf('.')
  const base = lastDotIndex > 0 ? name.slice(0, lastDotIndex) : name
  const ext = lastDotIndex > 0 ? name.slice(lastDotIndex + 1).toLowerCase() : 'jpg'
  const safeBase = base
    .toLowerCase()
    .replace(/[^a-z0-9\-_.]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^[-_.]+|[-_.]+$/g, '')
  return `${safeBase || 'image'}.${ext}`
}

export function makeUniqueImagePath(baseDir: string, originalFileName: string): string {
  const safeBaseDir = baseDir.replace(/\/+$/, '')
  return `${safeBaseDir}/${generateUniqueId()}-${sanitizeFileName(originalFileName)}`
}
